module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Langue du site internet"},"en":{"a":"Website language"}}')
  delete Component.options._Ctor
}
